exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".payments-container {\n  margin-top: 20px;\n  max-height: calc(100vh - 80px);\n  overflow: auto; }\n\n@media only screen and (max-width: 600px) {\n  .payments-container {\n    width: calc(100vw - 20px);\n    padding: 0 10px; }\n    .payments-container .custom-table {\n      margin-top: 20px; }\n    .payments-container .search-box {\n      min-width: 70%; } }\n\n/*\n@media only screen and (max-width: 500px) {\n    .payments-container {\n        width: 400px;\n    }\n}\n\n@media only screen and (max-width: 400px) {\n    .payments-container {\n        width: 300px;\n    }\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/payments/index.scss
// module id = 1557
// module chunks = 0